import Service from '@ember/service';
import config from '../config/environment';

class OptimizelyStub extends Service {
  initialize() {
    return Promise.resolve();
  }

  activate() {
    return Promise.resolve();
  }
}

export function initialize(application) {
  if (config.environment === 'test' || config.environment === 'development') {
    application.register('service:optimizely', OptimizelyStub);
  }
}

export default {
  initialize,
};
